module.exports = __webpack_public_path__ + "public/images/shark.b9fae082ee22003cb088ba5b7c5495a5.png";